
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';

interface ArticleErrorProps {
  error: string;
}

const ArticleError = ({ error }: ArticleErrorProps) => {
  const navigate = useNavigate();
  
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      <AlertCircle className="h-12 w-12 text-destructive mb-4" />
      <h1 className="text-xl font-bold mb-2">Article Not Found</h1>
      <p className="text-muted-foreground mb-6">{error}</p>
      <button 
        onClick={() => navigate('/')}
        className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90"
      >
        Return to Home
      </button>
    </div>
  );
};

export default ArticleError;
